import {createStrokeSVG} from './TEMPLATE'

// tabler: users
export const Group3_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M5 7a4 4 0 1 0 8 0a4 4 0 1 0 -8 0',
    'M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2',
    'M16 3.13a4 4 0 0 1 0 7.75',
    'M21 21v-2a4 4 0 0 0 -3 -3.85',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
